/**
 * Created by Victor Rojo on 3/3/20.
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortNumber'
})
export class ShortNumberPipe implements PipeTransform {

  transform(number: number, args?: any): any {
    if (isNaN(number))
      return null; // will only work value is a number
    if (number === null)
      return 0;
    if (number === 0)
      return 0;

    if (number.toString().includes(',')) {
      number = parseFloat(number.toString().replace(/\,/g, ''));
    }

    let abs = Math.abs(number);
    const rounder = Math.pow(10, 1);
    const isNegative = number < 0; // will also work for Negetive numbers
    let key = '';

    const powers = [
      { key: 'P', value: Math.pow(10, 15) },// peta
      { key: 'T', value: Math.pow(10, 12) },// tera
      { key: 'G', value: Math.pow(10, 9) }, // giga
      { key: 'M', value: Math.pow(10, 6) }, // mega
      { key: 'K', value: 1000 },            // kilo
      { key: '', value: 1 },
      //{ key: 'm', value: Math.pow(10, -3) }, // mili

    ];

    let rounded = false;

    for (let i = 0; i < powers.length; i++) {
      let reduced = abs / powers[i].value;
      reduced = Math.round(reduced * rounder) / rounder;
      if (reduced >= 1) {
        abs = reduced;
        key = powers[i].key;
        rounded = true;
        break;
      }
    }

    if ( !rounded ) {
      abs = Math.round(abs * rounder) / rounder;
    }

    return (isNegative ? '-' : '') + abs + key;
  }
}
